var _circle, _path, _rect, _path2, _path3, _path4, _circle2, _circle3, _circle4, _circle5, _line, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreetParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    stroke: "#103B5D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 48.1345L26 36.1345L53 36L50 48C52.8088 53.7436 50.7963 62.4375 41.5 63.5221C40.8673 63.5959 40.2009 63.6345 39.5 63.6345C28.5 63.6345 26 54.1345 29 48.1345Z",
    fill: "#103B5D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 63,
    width: 7,
    height: 16,
    fill: "#103B5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 36L29.5 19.5C32 18.2331 36.5 17 39.5 17C42.5 17 47 18.0986 49.5 19.3655L53 35.8655L50 47.8655C52.8088 53.6091 50.7963 62.303 41.5 63.3876C40.8673 63.4614 40.2009 63.5 39.5 63.5C28.5 63.5 26 54 29 48L26 36Z",
    stroke: "#103B5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4949 21C37.6297 21 34.9123 21.6134 33.1596 22.295C32.862 22.4108 32.6508 22.6739 32.5834 22.9861L31.6309 27.3944C31.5636 27.7059 31.8009 28 32.1196 28H46.8812C47.1996 28 47.4369 27.7063 47.37 27.395L46.4059 22.9069C46.3388 22.5942 46.1275 22.3302 45.8288 22.2161C44.0761 21.5462 41.3596 21 39.4949 21Z",
    stroke: "#103B5D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53 36L26 36",
    stroke: "#103B5D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 32,
    r: 1,
    fill: "#103B5D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 32,
    r: 1,
    fill: "#103B5D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 32,
    r: 1,
    fill: "#103B5D"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 32,
    r: 1,
    fill: "#103B5D"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 45,
    y1: 41.5,
    x2: 34,
    y2: 41.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 51.5L39.5 47.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 63.5V79.2667M36.5 63.5V79.2667",
    stroke: "#103B5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreetParking);
export default __webpack_public_path__ + "static/media/Street_Parking.3a036c894cff10a3d7ff67b4d13ddd51.svg";
export { ForwardRef as ReactComponent };